import { APP_VERSION } from '../../shared/site-config'

const steps = [
  ['데이터 수정', 'public/data/keyword-statistics.json 파일을 수정하거나 SQL 변환 명령을 실행합니다.'],
  ['계정 추가', 'functions/_shared/accounts.ts 배열에 계정을 추가합니다.'],
  ['버전 변경', 'shared/site-config.ts의 APP_VERSION 값을 변경합니다.'],
  ['배포', 'Git에 반영하면 Cloudflare Pages가 자동으로 빌드하고 배포합니다.'],
]

export default function GuidePage() {
  return (
    <section className="guide-page section-container">
      <div className="section-heading narrow">
        <span className="eyebrow">GUIDE</span>
        <h1>운영 방법</h1>
        <p>서버와 DB 없이 파일 변경과 재배포만으로 운영하는 구조입니다.</p>
      </div>

      <div className="guide-grid">
        {steps.map(([title, description], index) => (
          <article key={title}>
            <span>{String(index + 1).padStart(2, '0')}</span>
            <h2>{title}</h2>
            <p>{description}</p>
          </article>
        ))}
      </div>

      <div className="info-card">
        <div>
          <span className="info-label">현재 웹 버전</span>
          <strong>{APP_VERSION}</strong>
        </div>
        <p>상세 배포 및 이전 절차는 web/README.md와 MIGRATION_PLAN.md에 정리되어 있습니다.</p>
      </div>
    </section>
  )
}
